"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[818],{

/***/ 271073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ DiscountTagColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DiscountTagColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 9.5C21 9.914 20.664 10.25 20.25 10.25C19.395 10.25 18.75 10.895 18.75 11.75C18.75 12.605 19.395 13.25 20.25 13.25C20.664 13.25 21 13.586 21 14V17.75C21 18.164 20.664 18.5 20.25 18.5H3.75C3.336 18.5 3 18.164 3 17.75V14C3 13.586 3.336 13.25 3.75 13.25C4.605 13.25 5.25 12.605 5.25 11.75C5.25 10.895 4.605 10.25 3.75 10.25C3.336 10.25 3 9.914 3 9.5V5.75C3 5.336 3.336 5 3.75 5H20.25C20.664 5 21 5.336 21 5.75V9.5ZM10.5 9.125C10.5 8.504 9.996 8 9.375 8C8.754 8 8.25 8.504 8.25 9.125C8.25 9.746 8.754 10.25 9.375 10.25C9.996 10.25 10.5 9.746 10.5 9.125ZM13.5 14.375C13.5 14.996 14.004 15.5 14.625 15.5C15.246 15.5 15.75 14.996 15.75 14.375C15.75 13.754 15.246 13.25 14.625 13.25C14.004 13.25 13.5 13.754 13.5 14.375ZM9.53026 15.2802C9.23742 15.5731 8.76261 15.5731 8.46976 15.2802C8.17692 14.9874 8.17692 14.5126 8.46976 14.2197L14.4698 8.2197C14.7626 7.92685 15.2374 7.92685 15.5303 8.2197C15.8231 8.51255 15.8231 8.98735 15.5303 9.2802L9.53026 15.2802Z",
          fill: "url(#paint0_linear)"
        }
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "12",
              y1: "5",
              x2: "12",
              y2: "18.5",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 203494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RightOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RightOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.49976 19.0001L15.4998 12.0001L8.49976 5.00012",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 675601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: (typeof href === "string" ? href : href == null ? void 0 : href.pathname) || "",
    query: {},
    as
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as, setNewState]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  if (serverless) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href: href || "",
    as
  }, rest), {
    prefetch
  }), children);
};
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
  color: black;
  text-decoration: none;
`;




/***/ }),

/***/ 783834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ComboImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788925);




const IMAGE_LIMIT = 4;
const ComboImage = ({
  images,
  alt = [],
  keys = [],
  width,
  height,
  childHeight,
  childWidth,
  isContainBorder
}) => {
  const isSingleImage = images.length === 1;
  if (isSingleImage)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Image, {
      src: images.shift(),
      height: height || 80,
      width: width || 80,
      alt: "product"
    });
  const remainImage = images.length - IMAGE_LIMIT;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComboImageWrapper, {
    width,
    height
  }, images.slice(0, IMAGE_LIMIT).map((image, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ChildImage, {
    width: childWidth,
    height: childHeight,
    isContainBorder,
    src: image,
    alt: alt[index],
    key: keys[index] || index
  })), remainImage > 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RemainingNumber, null, "+", remainImage + 1));
};
const ComboImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => ({
  width: props.width ? `${props.width}px` : "80px",
  height: props.height ? `${props.height}px` : "80px",
  background: "#F8F8FC",
  borderRadius: "4px",
  position: "relative",
  cursor: "pointer"
}));
const ChildImage = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].img((props) => ({
  borderRadius: "4px",
  width: props.width ? `${props.width}px` : "34px",
  height: props.height ? `${props.height}px` : "34px",
  margin: "4px 0 0 4px",
  border: props.isContainBorder ? "solid 1px #E4E5F0" : "unset"
}));
const RemainingNumber = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 4px;
  background: rgba(27, 29, 41, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  border: 4px;
  right: 4px;
  bottom: 4px;
`;
const Image = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_2__/* .EnhancedImage */ .N)`
  border: 1px solid #e4e5f0;
`;




/***/ }),

/***/ 583576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(271073);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(628382);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(309110);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(811495);
/* harmony import */ var modules_cart_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(739069);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  max-height: 600px;\n  overflow-y: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








const MAX_DISPLAY_DESCRIPTIONS = 3;
const TierPromotions = (props)=>{
    const { productPromotions , isApplicableWithCombo =true , maxLinesBeforeEllipsis =1 , isCustomerTierPromotions =false ,  } = props;
    const { isMobile  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { 0: showDetail , 1: setShowDetail  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    // all promotions of an item (not being grouped)
    const allItemPromotions = (0,modules_cart_utils__WEBPACK_IMPORTED_MODULE_3__/* .flattenPromotionsFromPromotionGroups */ .Ou)(productPromotions);
    // all tier descriptions of an item (not being grouped)
    const allItemTierDescriptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const flattedTierDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousTierDescriptions, currentPromotion)=>[
                ...previousTierDescriptions,
                ...currentPromotion.tierDescriptions || [], 
            ], []) : [];
        return flattedTierDescriptions.length > 0 ? flattedTierDescriptions.filter((tierDesc)=>!!tierDesc.descriptions.length) : [];
    }, [
        allItemPromotions
    ]);
    const allItemHightLightDescriptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const flattedHightLightDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousHightLightDescriptions, currentPromotion)=>{
            var ref;
            return !!((ref = currentPromotion.highlightedDescriptions) === null || ref === void 0 ? void 0 : ref.length) ? [
                ...previousHightLightDescriptions,
                ...currentPromotion.highlightedDescriptions, 
            ] : previousHightLightDescriptions;
        }, []) : [];
        return flattedHightLightDescriptions;
    }, [
        allItemPromotions
    ]);
    const allItemCustomerTierDescription = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const flattedCustomerTierDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousTierDescriptions, currentPromotion)=>[
                ...previousTierDescriptions,
                ...currentPromotion.customerTierDescriptions || [], 
            ], []) : [];
        return flattedCustomerTierDescriptions;
    }, [
        allItemPromotions
    ]);
    // displaying tier descriptions limit to MAX_DISPLAY_DESCRIPTIONS
    const displayTierDescriptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return allItemTierDescriptions.length > MAX_DISPLAY_DESCRIPTIONS ? allItemTierDescriptions.slice(0, MAX_DISPLAY_DESCRIPTIONS) : allItemTierDescriptions;
    }, [
        allItemTierDescriptions
    ]);
    const handleCloseDetailModal = ()=>{
        setShowDetail(false);
    };
    const renderDetailContent = ()=>{
        return allItemTierDescriptions.map((tierDesc, index)=>{
            var ref;
            return ((ref = tierDesc.descriptions) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TierDescList, {
                marginBottom: index !== allItemTierDescriptions.length - 1 ? "8px" : "0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: tierDesc.title
                    }),
                    ":",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    tierDesc.descriptions.map((desc, subIndex)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: desc
                        }, "".concat(index, "-").concat(subIndex));
                    })
                ]
            }, index) : null;
        });
    };
    if (!allItemTierDescriptions.length && !isCustomerTierPromotions || isCustomerTierPromotions && !allItemCustomerTierDescription.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !!displayTierDescriptions.length || !!allItemCustomerTierDescription.length && isCustomerTierPromotions ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
                border: "1px solid #FFEED9",
                borderRadius: "s",
                backgroundColor: "#FFFBF5",
                padding: "s8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                        justify: "start",
                        align: "middle",
                        marginBottom: "s4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledCol, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .DiscountTagColored */ .G, {
                                    size: 20,
                                    color: "#FFA940"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                                    weight: "bold",
                                    color: "#FA8C16",
                                    margin: [
                                        "s0",
                                        "s0",
                                        "s0",
                                        "s4"
                                    ],
                                    children: isCustomerTierPromotions ? (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Ưu đ\xe3i kh\xe1ch h\xe0ng th\xe0nh vi\xean") : (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Mua nhiều th\xeam ưu đ\xe3i")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                        paddingLeft: "s8",
                        marginBottom: "s4",
                        justify: "start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .JX, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
                                borderLeft: "2px solid #FFEED9",
                                padding: [
                                    "s0",
                                    "s12"
                                ],
                                children: isCustomerTierPromotions ? allItemCustomerTierDescription.map((tierDesc, index)=>{
                                    return !!tierDesc.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                                        weight: "regular",
                                        line: maxLinesBeforeEllipsis,
                                        color: "#FA8C16",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledText, {
                                                fontWeight: "bold",
                                                color: "#FA8C16",
                                                children: [
                                                    tierDesc.title,
                                                    ",",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledText, {
                                                color: "#FA8C16",
                                                children: tierDesc.description
                                            })
                                        ]
                                    }, index) : null;
                                }) : displayTierDescriptions.map((tierDesc, index)=>{
                                    var ref, ref1;
                                    return ((ref = tierDesc.descriptions) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                                        weight: "regular",
                                        line: maxLinesBeforeEllipsis,
                                        color: "#FA8C16",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledText, {
                                                fontWeight: "bold",
                                                color: "#FA8C16",
                                                children: [
                                                    tierDesc.title,
                                                    ",",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledText, {
                                                color: "#FA8C16",
                                                children: (ref1 = tierDesc.descriptions) === null || ref1 === void 0 ? void 0 : ref1.join(" & ")
                                            })
                                        ]
                                    }, index) : null;
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                        justify: !isApplicableWithCombo || !!allItemHightLightDescriptions.length ? "space-between" : "end",
                        align: "bottom",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .JX, {
                                children: [
                                    !isApplicableWithCombo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                                        align: "middle",
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__/* .InforOutlined */ .l, {
                                                size: 16,
                                                color: "#FAAD14"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                                                weight: "regular",
                                                color: "#FAAD14",
                                                margin: [
                                                    "s0",
                                                    "s0",
                                                    "s0",
                                                    "s4"
                                                ],
                                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Kh\xf4ng \xe1p dụng c\xf9ng combo")
                                            })
                                        ]
                                    }),
                                    !!allItemHightLightDescriptions.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                                        align: "middle",
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__/* .InforOutlined */ .l, {
                                                size: 16,
                                                color: "#FAAD14"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT, {
                                                weight: "regular",
                                                color: "#FAAD14",
                                                margin: [
                                                    "s0",
                                                    "s0",
                                                    "s0",
                                                    "s4"
                                                ],
                                                children: allItemHightLightDescriptions[0]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isCustomerTierPromotions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .JX, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledDetailButton, {
                                    level: 1,
                                    onClick: ()=>setShowDetail(true),
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Xem chi tiết")
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            !!showDetail && (!!isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBottomSheet, {
                show: showDetail,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Chi tiết khuyến m\xe3i"),
                closeBottomSheet: handleCloseDetailModal,
                backdropClicked: handleCloseDetailModal,
                contentHeight: "500px",
                zIndex: 1060,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
                    padding: [
                        "s4",
                        "s16"
                    ],
                    children: renderDetailContent()
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledModal, {
                width: 600,
                visible: showDetail,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Chi tiết khuyến m\xe3i"),
                centeredTitle: true,
                okText: "",
                cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Đ\xf3ng"),
                onCancel: handleCloseDetailModal,
                onClose: handleCloseDetailModal,
                showCloseIcon: false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledModalBody, {
                    children: renderDetailContent()
                })
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TierPromotions);
const StyledDetailButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Body */ .uT)((param)=>{
    let { theme  } = param;
    return "\n  cursor: pointer;\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.link500, ";\n\n  :hover {\n    color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.error500, ";\n  }\n\n  &.is-disabled {\n    opacity: 0.5;\n    cursor: default;\n    color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.textSecondary, ";\n  }\n");
});
const StyledModal = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Modal */ .u)(_templateObject());
const StyledModalBody = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .ModalBody */ .f)(_templateObject1());
const TierDescList = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"].ul((param)=>{
    let { marginBottom  } = param;
    return "\n  list-style-position: inside;\n  margin-bottom: ".concat(marginBottom, ";\n");
});
const StyledText = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"].span((param)=>{
    let { color , fontWeight , fontSize ="13px" , margin  } = param;
    return "\n  color: ".concat(color, ";\n  font-weight: ").concat(fontWeight, ";\n  font-size: ").concat(fontSize, ";\n  margin: ").concat(margin, "\n");
});
const StyledCol = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .JX)(_templateObject2());
const StyledBottomSheet = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__/* .BottomSheet */ .R)(_templateObject3());


/***/ }),

/***/ 736422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nf": function() { return /* binding */ ORDER_SELLER_SKUS_MAPPING_KEY; },
/* harmony export */   "V7": function() { return /* binding */ MAPPING_TAB_ORDER; },
/* harmony export */   "iv": function() { return /* binding */ MAPPING_TAB_ORDER_REVERT; },
/* harmony export */   "x8": function() { return /* binding */ ORDER_TABS; },
/* harmony export */   "xC": function() { return /* binding */ ORDER_SESSION_STORAGE_KEY; }
/* harmony export */ });
/* harmony import */ var _teko_order__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(702217);



const ORDER_TABS = [
    {
        id: _teko_order__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TAB_WAIT_PAYMENT */ .T0,
        title: "Chờ thanh to\xe1n"
    },
    {
        id: _teko_order__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TAB_PROCESSING */ .p$,
        title: "Chờ giao h\xe0ng"
    },
    {
        id: _teko_order__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TAB_DONE */ .CN,
        title: "Đ\xe3 ho\xe0n th\xe0nh"
    }, 
];
const MAPPING_TAB_ORDER = {
    WAIT_PAYMENT: 0,
    PROCESSING: 1,
    DONE: 2
};
const MAPPING_TAB_ORDER_REVERT = {
    0: "WAIT_PAYMENT",
    1: "PROCESSING",
    2: "DONE"
};
const ORDER_SESSION_STORAGE_KEY = "theLastOrder";
const ORDER_SELLER_SKUS_MAPPING_KEY = "sellerSkusMapping";


/***/ }),

/***/ 305857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useFormatNumber; }
/* harmony export */ });
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(684443);

const useFormatNumber = ()=>{
    const { numberDisplayFormat  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_0__/* .useTenantConfig */ .Wx)();
    const formatNumber = (number)=>{
        if (!numberDisplayFormat) {
            return undefined;
        } else {
            // split decimal part
            const part = number.toString().split(".");
            // add thousand separator
            let res = part[0].replace(/\B(?=(\d{3})+(?!\d))/g, numberDisplayFormat.thousandSeparator);
            // add decimal separator
            if (part[1]) res = res + numberDisplayFormat.decimalSeparator + part[1];
            return res;
        }
    };
    return formatNumber;
};


/***/ }),

/***/ 368735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ AvailableLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(621655);



const AvailableLeft = (param)=>{
    let { displayTotalAvailable , isMobile =false  } = param;
    return isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Caption */ .YS, {
        level: 1,
        color: "warning",
        children: displayTotalAvailable
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_1__/* .Caption */ .YS, {
        level: 1,
        color: "warning",
        children: displayTotalAvailable
    });
};


/***/ }),

/***/ 806656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ ProductNoteInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(209705);
/* harmony import */ var _CartContextV2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(534090);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(634655);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(381301);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 0.5rem;\n  > :first-child {\n    resize: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






const StyledTextArea = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Textarea */ .g)(_templateObject());
const ProductNoteInput = (param)=>{
    let { item  } = param;
    const { onUpdateItemNote  } = (0,_CartContextV2__WEBPACK_IMPORTED_MODULE_4__/* .useCartV2 */ .T6)();
    const { disableAddItemNote  } = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getDisabledUserActions */ .n)(item);
    const { 0: productNote , 1: setProductNote  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(item.note || "");
    const previousProductNote = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(productNote);
    const handleBlur = ()=>{
        if (previousProductNote.current !== productNote) {
            onUpdateItemNote(item, productNote);
            previousProductNote.current = productNote;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledTextArea, {
        placeholder: (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Ghi ch\xfa sản phẩm"),
        value: productNote,
        rows: 1,
        maxLength: 1000,
        onChange: (value)=>setProductNote(value),
        onBlur: handleBlur,
        disabled: disableAddItemNote
    });
};


/***/ }),

/***/ 408128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ProductPrice; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(853675);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(476127);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(305857);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





const Price = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F)(()=>"\n    font-size: 1rem;\n    font-weight: bold;\n  ");
const StrikeThroughPrice = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].span((param)=>{
    let { theme  } = param;
    return "\n  text-decoration: line-through;\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.textSecondary, ";\n  font-size: 0.75rem;\n");
});
const StyledEditOutlined = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .EditOutlined */ .p)((param)=>{
    let { theme  } = param;
    return "\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.link500, ";\n  &.is-disabled {\n    opacity: 0.5;\n    color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.textSecondary, "\n  }\n");
});
const ProductPrice = (param)=>{
    let { price , editable =false , onEditPrice , disableEditItemPrice =false , strikeThroughDisplayPrice , isDesktop  } = param;
    const formatNumber = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useFormatNumber */ .D)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .JX, {
        children: [
            price >= 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, _objectSpreadProps(_objectSpread({
                align: "middle"
            }, isDesktop && {
                justify: "end"
            }), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Price, {
                        value: price,
                        formattedValue: formatNumber(price),
                        className: "product-price__price"
                    }),
                    editable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledEditOutlined, _objectSpread({
                        size: 22,
                        className: disableEditItemPrice ? "is-disabled" : ""
                    }, disableEditItemPrice ? {} : {
                        onClick: onEditPrice
                    }))
                ]
            })),
            !!strikeThroughDisplayPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, _objectSpreadProps(_objectSpread({
                align: "middle"
            }, isDesktop && {
                justify: "end"
            }), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StrikeThroughPrice, {
                    className: "product-price__listed-price att-strike-through-display-price",
                    children: strikeThroughDisplayPrice
                })
            }))
        ]
    });
};


/***/ }),

/***/ 381301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ checkEnableSellerCheckbox; },
/* harmony export */   "n": function() { return /* binding */ getDisabledUserActions; }
/* harmony export */ });
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891004);
// Util functions for cart item

/**
 * return object of disabled actions of each Cart Item
 *
 * @param cartItem (CartItem)
 */ const getDisabledUserActions = (cartItem)=>{
    const itemAllowedUserActions = cartItem.allowedUserActions || [];
    return {
        disableCheckItem: !itemAllowedUserActions.includes(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_0__/* .AllowedUserActionItem.TOGGLE */ .rV.TOGGLE),
        disableChangeItemQuantity: !itemAllowedUserActions.includes(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_0__/* .AllowedUserActionItem.CHANGE_QUANTITY */ .rV.CHANGE_QUANTITY),
        disableDeleteItem: !itemAllowedUserActions.includes(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_0__/* .AllowedUserActionItem.DELETE */ .rV.DELETE),
        disableEditItemPrice: !itemAllowedUserActions.includes(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_0__/* .AllowedUserActionItem.REQUEST_CONSULTATION_FEE */ .rV.REQUEST_CONSULTATION_FEE),
        disableAddItemNote: !itemAllowedUserActions.includes(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_0__/* .AllowedUserActionItem.ADD_NOTE */ .rV.ADD_NOTE)
    };
};
/**
 * logic to check if seller checkbox is enabled/disabled
 * return enable if at least one of its item's allowedUserActions contains TOGGLE value
 * if every item's allowedUserActions doesn't have TOGGLE value, return disable
 *
 * @param items: items of that seller
 */ const checkEnableSellerCheckbox = (items)=>{
    if (!items.length) return false;
    return items.some((item)=>!!item.allowedUserActions ? item.allowedUserActions.includes(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_0__/* .AllowedUserActionItem.TOGGLE */ .rV.TOGGLE) : false);
};


/***/ }),

/***/ 778625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ITEM_UPDATE_DEBOUNCE_TIME; }
/* harmony export */ });
const ITEM_UPDATE_DEBOUNCE_TIME = 300;


/***/ }),

/***/ 857387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ PROMOTION_TYPE; },
/* harmony export */   "s": function() { return /* binding */ BENEFIT_TYPE; }
/* harmony export */ });
var BENEFIT_TYPE;
(function(BENEFIT_TYPE) {
    BENEFIT_TYPE["voucher"] = "voucher";
    BENEFIT_TYPE["gifts"] = "gifts";
    BENEFIT_TYPE["discount"] = "discount";
})(BENEFIT_TYPE || (BENEFIT_TYPE = {}));
var PROMOTION_TYPE;
(function(PROMOTION_TYPE) {
    PROMOTION_TYPE["magento"] = "magento";
    PROMOTION_TYPE["customMagento"] = "customMagento";
})(PROMOTION_TYPE || (PROMOTION_TYPE = {}));


/***/ }),

/***/ 702217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A5": function() { return /* binding */ ORDER_TAB_WAIT_CONFIRM; },
/* harmony export */   "CN": function() { return /* binding */ ORDER_TAB_DONE; },
/* harmony export */   "D4": function() { return /* binding */ ORDER_SHIPMENT_STATUS; },
/* harmony export */   "K": function() { return /* binding */ CONSUMER_ORDER_STATUSES; },
/* harmony export */   "KM": function() { return /* binding */ STAFF_ORDER_STATES; },
/* harmony export */   "MS": function() { return /* binding */ ORDER_STATE_DELIVERED; },
/* harmony export */   "NK": function() { return /* binding */ ORDER_CUSTOMER_STATE_DELIVERING; },
/* harmony export */   "QM": function() { return /* binding */ STAFF_ORDER_STATUS_CREATED; },
/* harmony export */   "SQ": function() { return /* binding */ ORDER_TAB_DELIVERED; },
/* harmony export */   "Sw": function() { return /* binding */ STAFF_ORDER_STATUS_PAYMENT_CONFIRMED; },
/* harmony export */   "T0": function() { return /* binding */ ORDER_TAB_WAIT_PAYMENT; },
/* harmony export */   "VI": function() { return /* binding */ ORDER_TAB_CANCELED; },
/* harmony export */   "Xf": function() { return /* binding */ STAFF_ORDER_STATUS_DELIVERED; },
/* harmony export */   "aA": function() { return /* binding */ ORDER_TAB_WAIT_DELIVER; },
/* harmony export */   "aD": function() { return /* binding */ STATUS_COLOR; },
/* harmony export */   "bx": function() { return /* binding */ STAFF_ORDER_STATUS_CANCELLED_DRAFT; },
/* harmony export */   "dh": function() { return /* binding */ STAFF_ORDER_STATUS_DELIVERING; },
/* harmony export */   "iM": function() { return /* binding */ orderStatus; },
/* harmony export */   "lz": function() { return /* binding */ STAFF_ORDER_STATUS_WAIT_FOR_PROCESS; },
/* harmony export */   "oU": function() { return /* binding */ ORDER_CUSTOMER_STATE_WAITING_DELIVERY; },
/* harmony export */   "p$": function() { return /* binding */ ORDER_TAB_PROCESSING; },
/* harmony export */   "rD": function() { return /* binding */ STAFF_ORDER_STATUS_NEED_REFUND; },
/* harmony export */   "uT": function() { return /* binding */ STAFF_ORDER_STATUS_PROCESSING; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404998);


const ORDER_TAB_WAIT_PAYMENT = 0;
const ORDER_TAB_WAIT_CONFIRM = 1;
const ORDER_TAB_WAIT_DELIVER = 1;
const ORDER_TAB_PROCESSING = 1;
const ORDER_TAB_DELIVERED = 2;
const ORDER_TAB_CANCELED = 2;
const ORDER_TAB_DONE = 2;
const ORDER_STATE_DELIVERED = "DELIVERED";
const ORDER_CUSTOMER_STATE_WAITING_DELIVERY = 1;
const ORDER_CUSTOMER_STATE_DELIVERING = 2;
const STAFF_ORDER_STATUS_CREATED = "CREATED";
const STAFF_ORDER_STATUS_PAYMENT_CONFIRMED = "PAYMENT_CONFIRMED";
const STAFF_ORDER_STATUS_CANCELLED_DRAFT = "CANCELLED_DRAFT";
const STAFF_ORDER_STATUS_DELIVERED = "DELIVERED";
const STAFF_ORDER_STATUS_DELIVERING = "DELIVERING";
const STAFF_ORDER_STATUS_WAIT_FOR_PROCESS = "WAIT_FOR_PROCESS";
const STAFF_ORDER_STATUS_PROCESSING = "PROCESSING";
const STAFF_ORDER_STATUS_NEED_REFUND = "NEED-REFUND";
const STAFF_ORDER_STATES = {
  new: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("\u0110\u01A1n m\u1EDBi t\u1EA1o"),
  active: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("Ch\u1EDD thanh to\xE1n"),
  paid: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("\u0110\xE3 thanh to\xE1n"),
  processing: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("\u0110ang x\u1EED l\xFD"),
  cancelled: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("\u0110\xE3 h\u1EE7y"),
  delivered: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("\u0110\xE3 giao h\xE0ng"),
  returned: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("\u0110\xE3 tr\u1EA3 h\xE0ng"),
  reverted: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("\u0110\xE3 tr\u1EA3 h\xE0ng"),
  refund: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("\u0110\xE3 ho\xE0n ti\u1EC1n")
};
const STATUS_COLOR = {
  waiting: "",
  processing: "#f78212",
  success: "#53c305",
  canceled: "#d60f29"
};
const CONSUMER_ORDER_STATUSES = [
  {
    status: "DRAFT",
    text: null,
    displayStatus: null,
    tab: null,
    color: ""
  },
  {
    status: "WAITING_FOR_APPROVAL",
    text: "Ch\u1EDD duy\u1EC7t",
    displayStatus: "Ch\u1EDD duy\u1EC7t",
    tab: null,
    color: ""
  },
  {
    status: "CREATED",
    text: null,
    displayStatus: null,
    tab: null,
    color: ""
  },
  {
    status: "PENDING",
    text: "Ch\u1EDD x\xE1c nh\u1EADn",
    displayStatus: "Ch\u1EDD x\xE1c nh\u1EADn",
    tab: ORDER_TAB_WAIT_PAYMENT,
    color: STATUS_COLOR.processing
  },
  {
    status: "PROCESSING",
    text: "\u0110ang x\u1EED l\xFD",
    displayStatus: "\u0110ang x\u1EED l\xFD",
    tab: ORDER_TAB_PROCESSING,
    color: STATUS_COLOR.processing
  },
  {
    status: "WAITING_FOR_PAYMENT_CONFIRMATION",
    text: "Ch\u1EDD thanh to\xE1n",
    displayStatus: "Ch\u1EDD thanh to\xE1n",
    tab: ORDER_TAB_WAIT_PAYMENT,
    color: STATUS_COLOR.processing
  },
  {
    status: "PAYMENT_CONFIRMED",
    text: "\u0110\xE3 thanh to\xE1n",
    displayStatus: "\u0110\xE3 thanh to\xE1n",
    tab: ORDER_TAB_PROCESSING,
    color: STATUS_COLOR.processing
  },
  {
    status: "CANCELLED",
    text: "\u0110\xE3 h\u1EE7y",
    displayStatus: "\u0110\xE3 h\u1EE7y",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.canceled
  },
  {
    status: "REVERTED",
    text: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    displayStatus: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.canceled
  },
  {
    status: "RETURNED",
    text: "Tr\u1EA3 h\xE0ng",
    displayStatus: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.canceled
  },
  {
    status: "REFUND",
    text: "Tr\u1EA3 h\xE0ng",
    displayStatus: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.canceled
  },
  {
    status: "NEED_REFUND",
    text: "Tr\u1EA3 h\xE0ng",
    displayStatus: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.canceled
  },
  {
    status: "DELIVERING",
    text: "\u0110ang giao h\xE0ng",
    displayStatus: "\u0110ang giao h\xE0ng",
    tab: ORDER_TAB_PROCESSING,
    color: STATUS_COLOR.processing
  },
  {
    status: "DELIVERED",
    text: "Ho\xE0n th\xE0nh",
    displayStatus: "Ho\xE0n th\xE0nh",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.success
  }
];
const ORDER_SHIPMENT_STATUS = [
  {
    status: "NEW",
    displayStatus: "M\u1EDBi",
    color: STATUS_COLOR.processing
  },
  {
    status: "WAITING_FOR_MANUAL_CONFIRMATION",
    displayStatus: "Ch\u1EDD x\xE1c nh\u1EADn",
    color: STATUS_COLOR.processing
  },
  {
    status: "PROVIDER_TRANSFERRING",
    displayStatus: "\u0110\xE3 ti\u1EBFp nh\u1EADn",
    color: STATUS_COLOR.processing
  },
  {
    status: "PROVIDER_TRANSFERRED",
    displayStatus: "\u0110\xE3 ti\u1EBFp nh\u1EADn",
    color: STATUS_COLOR.processing
  },
  {
    status: "WAIT_FOR_PRODUCT",
    displayStatus: "Ch\u1EDD l\u1EA5y h\xE0ng",
    color: STATUS_COLOR.processing
  },
  {
    status: "WAITING_FOR_PRODUCT",
    displayStatus: "Ch\u1EDD giao h\xE0ng",
    color: STATUS_COLOR.processing
  },
  {
    status: "PICKING",
    displayStatus: "\u0110ang l\u1EA5y h\xE0ng",
    color: STATUS_COLOR.processing
  },
  {
    status: "PICKED",
    displayStatus: "\u0110\xE3 l\u1EA5y h\xE0ng",
    color: STATUS_COLOR.processing
  },
  {
    status: "PACKED",
    displayStatus: "\u0110\xF3ng g\xF3i xong",
    color: STATUS_COLOR.processing
  },
  {
    status: "DELIVERING",
    displayStatus: "\u0110ang giao",
    color: STATUS_COLOR.processing
  },
  {
    status: "DELIVERED",
    displayStatus: "\u0110\xE3 giao",
    color: STATUS_COLOR.success
  },
  {
    status: "PARTIAL_DELIVERED",
    displayStatus: "Giao m\u1ED9t ph\u1EA7n",
    color: STATUS_COLOR.processing
  },
  {
    status: "RETURNED",
    displayStatus: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    color: STATUS_COLOR.success
  },
  {
    status: "PARTIAL_CANCELLED",
    displayStatus: "\u0110\xE3 h\u1EE7y",
    color: STATUS_COLOR.success
  },
  {
    status: "CANCELLED",
    displayStatus: "\u0110\xE3 h\u1EE7y",
    color: STATUS_COLOR.canceled
  },
  {
    status: "PROCESSING",
    displayStatus: "Ch\u1EDD giao h\xE0ng",
    color: STATUS_COLOR.processing
  },
  {
    status: "DELIVERED_AT_AGENCY",
    displayStatus: "\u0110\xE3 giao \u0111\u1EA1i l\xFD",
    color: STATUS_COLOR.processing
  },
  {
    status: "WAITING_FOR_WAREHOUSE_CONFIRMATION",
    displayStatus: "Ch\u1EDD x\xE1c nh\u1EADn",
    color: STATUS_COLOR.processing
  },
  {
    status: "WAITING_FOR_BACKORDER_CONFIRMATION",
    displayStatus: "Ch\u1EDD x\xE1c nh\u1EADn",
    color: STATUS_COLOR.processing
  },
  {
    status: "BACKORDERING",
    displayStatus: "Ch\u1EDD h\xE0ng v\u1EC1",
    color: STATUS_COLOR.processing
  },
  {
    status: "BACKORDER_INSUFFICIENT_STOCK",
    displayStatus: "Ch\u1EDD h\xE0ng v\u1EC1",
    color: STATUS_COLOR.processing
  }
];
const orderStatus = {
  WAITING_FOR_MANUAL_CONFIRMATION: "WAITING_FOR_MANUAL_CONFIRMATION",
  WAIT_FOR_PROCESS: "WAIT_FOR_PROCESS",
  PROCESSING: "PROCESSING",
  DELIVERED: "DELIVERED",
  PAYMENT_CONFIRMED: "PAYMENT_CONFIRMED",
  PAID: "PAID",
  PENDING: "PENDING",
  WAITING_FOR_PAYMENT_CONFIRMATION: "WAITING_FOR_PAYMENT_CONFIRMATION",
  CANCELLED: "CANCELLED",
  REVERTED: "REVERTED",
  RETURNED: "RETURNED",
  CONFIRMED: "CONFIRMED",
  WAITING_FOR_PICKING: "WAITING_FOR_PICKING",
  PACKED: "PACKED",
  DELIVERING: "DELIVERING",
  READY_FOR_PICKUP: "READY_FOR_PICKUP",
  REFUND: "REFUND"
};




/***/ }),

/***/ 404998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../packages/order/dist/lang/vi.es.js
var viLang = {
	
};



;// CONCATENATED MODULE: ../../packages/order/dist/lang/en.es.js
var enLang = {
	"Đơn mới tạo": "Created",
	"Chờ thanh toán": "Waiting for payment",
	"Đã thanh toán": "Payment confirmed",
	"Đang xử lý": "Processing",
	"Đã hủy": "Cancelled",
	"Đã giao hàng": "Delivered",
	"Đã trả hàng": "Returned",
	"Đã hoàn tiền": "Refunded",
	"Chờ duyệt": "Waiting for approval",
	"Chờ xác nhận": "Waiting for confirmation",
	"Trả hàng": "Returning",
	"Đang giao hàng": "Delivering",
	"Hoàn thành": "Completed",
	"Chờ giao hàng": "Waiting for delivery",
	"Đang giao": "Delivering",
	"Đã giao": "Delivered",
	"Đã giao đại lý": "Delivered at agency",
	"Mới": "New",
	"Chờ hàng về": "Waiting for products",
	"Thanh toán trả chậm": "Deferred Payment",
	"Đã tiếp nhận": "Received",
	"Chờ đủ hàng": "Waiting for enough stock",
	"Chờ lấy hàng": "Waiting for products",
	"Đang lấy hàng": "Picking",
	"Đã lấy hàng": "Picked",
	"Đóng gói xong": "Packed",
	"Giao một phần": "Partial delivered"
};



;// CONCATENATED MODULE: ../../packages/order/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "order";
const t = (keys, options) => {
  return i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), {
    ns: NAMESPACE,
    interpolation: { escapeValue: false }
  }));
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ })

}]);